var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 127,
    viewBox: "0 0 1440 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 45.3571L60 52.1607C120 58.9643 240 72.5714 360 68.0357C480 63.5 600 40.8214 720 24.9464C840 9.07143 960 0 1080 0C1200 0 1320 9.07143 1380 13.6071L1440 18.1429V127H1380C1320 127 1200 127 1080 127C960 127 840 127 720 127C600 127 480 127 360 127C240 127 120 127 60 127H0V45.3571Z",
    fill: "url(#paint0_linear_5347_12159)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5347_12159",
    x1: 6.84834e-7,
    y1: 59.7586,
    x2: 1434.76,
    y2: 148.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTop);
export default __webpack_public_path__ + "static/media/footer-top.60531fb259ba7d1c78359c7564d0a637.svg";
export { ForwardRef as ReactComponent };